import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { validateParty } from "../../validation/PartyInfo.tsx/Index";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
import Partyinfo from "./PartyForm";

const CustomerCreate = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
    watch,
  } = useForm<any>({
    resolver: yupResolver(validateParty),
  });

  return (
    <div>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, setError))}
          autoComplete="off"
        >
          <Partyinfo
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            watch={watch}
          />
          <div className={tw`mt-4 w-full px-4 `}>
            <div className={tw`w-32 ml-auto`}>
              <Button label="Create" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default CustomerCreate;
